package org.hs_soft.runmynesto.domain.model.home.options.export.option_credit_card

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class OptionCreditCardModel(
    @SerialName("data")
    val data: Data?,
    @SerialName("errors")
val errors: List<GeneralError?>?=null,
)